import { Error } from 'models/Error';

export const defaultErrorResponse: Error = {
  message: 'Something went wrong',
};
